import { render, staticRenderFns } from "./AccountingCategoriesModal.vue?vue&type=template&id=b077c3d6"
import script from "./AccountingCategoriesModal.vue?vue&type=script&lang=ts"
export * from "./AccountingCategoriesModal.vue?vue&type=script&lang=ts"
import style0 from "./AccountingCategoriesModal.vue?vue&type=style&index=0&id=b077c3d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports